import React from 'react';
import Select from 'material-ui-beta/Select';
import {MenuItem} from 'material-ui-beta/Menu';
import Card, {CardContent} from 'material-ui-beta/Card';
import {CircularProgress} from 'material-ui-beta/Progress';

import api from '../../api/api';
import attributeIds from '../../api/attributeIds';
import GoogleHeatMap from '../google-heat-map';

import './index.css';

class AdminLocationReport extends React.Component {

    state = {
        specialties: null,
        points: null,
        filteredPoints: null,
        selectedSpecialties: null,
        totalClaimed: 0
    };

    componentDidMount() {
        api.getAllLocations(locations => {
            let points = locations.map(location => ({
                key: location.key,
                lat: location.latitude,
                lng: location.longitude,
                specialties: location.attributes ? location.attributes[attributeIds.practiceSpecialty] : null,
                claimed: location.orgId !== null && location.orgId !== undefined,
            }));

            console.log("points", points);

            let totalClaimed = points.reduce((total, point) => {
                if (total instanceof Object) {
                    total = (total.claimed ? 1 : 0)
                }

                return total + (point.claimed ? 1 : 0);
            });

            this.setState({
                points,
                totalClaimed
            })
        });

        api.fetchSpecialties().then(snapshot => {
            let options = snapshot.val().options;
            this.setState({
                specialties: sortAlphabetically(Object.keys(options).map(key => ({key, name: options[key].name}))),
            })
        });
    }

    onSelectChange = (event) => {
        console.log("onSelectChanged", event.target.name, event.target.value);

        let filteredPoints = null;

        if (event.target.value.length > 0) {
            filteredPoints = this.state.points.filter(point => {
                let result = true;

                event.target.value.forEach(value => {
                    if (point.specialties && point.specialties.choice.indexOf(value) === -1) {
                        result = false;
                    }
                });

                return result;
            });
        }

        this.setState({
            [event.target.name]: event.target.value !== "-1" ? event.target.value : null,
            filteredPoints,
            totalClaimed: (filteredPoints === null ? this.state.points : filteredPoints).reduce((total, point) => {
                if (total instanceof Object) {
                    total = (total.claimed ? 1 : 0)
                }

                return total + (point.claimed ? 1 : 0);
            })
        });
    };

    getPoints() {
        return this.state.filteredPoints ? this.state.filteredPoints : this.state.points;
    }

    render() {
        const {points, totalClaimed, specialties} = this.state;

        if (points) {
            return (
                <div className="admin-query-report-container flex1 flex column">
                    <div className="admin-query-report-controls">
                        <Card>
                            <CardContent>
                                <div className="flex">
                                    <div className="admin-location-report-specialties">
                                        <div className="admin-query-report-label">
                                            Specialty
                                        </div>
                                        <div>
                                            {this.state.specialties ?
                                                <Select
                                                    multiple
                                                    name="selectedSpecialties"
                                                    onChange={this.onSelectChange}
                                                    value={this.state.selectedSpecialties || []}
                                                    renderValue={selected => (
                                                        <span className="admin-location-report-specialties">
                                                            {getSpecialtyByKey(selected[0], specialties).name} {selected.length > 1 ? `(+${selected.length - 1} more)` : null}
                                                        </span>
                                                    )}>
                                                    {this.state.specialties.map(specialty => {
                                                        return (
                                                            <MenuItem key={`specialty-${specialty.key}`}
                                                                      value={specialty.key}>
                                                                {specialty.name}
                                                            </MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                                :
                                                <CircularProgress size={30} />
                                            }
                                        </div>
                                    </div>
                                    <div className="marginLeft30">
                                        <div className="admin-query-report-label">
                                            Total # Locations
                                        </div>
                                        <div className="marginTop10">
                                            {this.getPoints().length}
                                        </div>
                                    </div>
                                    <div className="marginLeft30">
                                        <div className="admin-query-report-label">
                                            # Claimed Locations
                                        </div>
                                        <div className="marginTop10">
                                            {totalClaimed}
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                    <div className="flex1 relative">
                        <GoogleHeatMap data={this.getPoints()} />
                    </div>
                </div>
            )
        }
        return (
            <div className="admin-query-report-container flex center">
                <div className="marginTop30">
                    <CircularProgress size={45} />
                </div>
            </div>
        )

    }
}

function sortAlphabetically(list) {
    list.sort((item1, item2) => item1.name.localeCompare(item2.name));
    return list;
}

function getSpecialtyByKey(key, specialties) {
    return specialties.find(specialty => specialty.key === key);
}

export default AdminLocationReport;


// WEBPACK FOOTER //
// ./src/components/admin-location-report/index.js